import { PageName } from '@anm/data/video-templates/pages';
import { createContext } from 'react';

export type PageProps = { pageName: PageName };

export const VideoTemplatesPageContext = createContext({} as PageProps);

export const VideoTemplatesPageProvider = VideoTemplatesPageContext.Provider;
